<template lang="pug">
  .dashboard-container
    .username {{ userName }}
</template>

<script>
import { getUserInfo } from '../../utils/auth';

export default {
  name: 'Dashboard',
  computed: {
    userName() {
      return getUserInfo().user.userName;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
    color:white;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/index.vue?6a670032